<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/remote-reply-call/feature/summary.jpg'"
        :altText="`長距離通信リモートリプライコール`"
        :headerText="
          `電波到達距離が大幅にアップ！
        32 文字（256 通り）のメッセージで、お客様を確実に誘導します！`
        "
        :detailText="
          `リプライコールの性能を更に強化。これまでの通信距離を大幅に拡大し、お客様が近隣にいなくても呼び出しができるようになりました。
        音・振動に加え、文字情報 (32 文字以内)で確実にお知らせ。大型ショッピングモールやアミューズメント施設等での呼び出しに最適です。`
        "
        :color="'green'"
      />

      <div class="feature-content">
        <content-header
          title="新無線技術を採用！通信距離が飛躍的に拡大！"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <p>
          LPWA（Low Power Wide
          Area=消費電力を抑えて遠距離通信を実現する通信方式）
          の一つとして注目を浴びている新無線技術ARIB STD-T108 規格
          対応のアクティブ無線システムを採用。
          920MHz帯の電波なので電波の到達エリアが広く、障害物があっても回り込んで届きます。
        </p>
        <p>
          中継機 ( 最大 2 台まで )
          を利用すれば通信可能エリアはさらに広がります。
        </p>
        <div class="appeal-block">
          <span class="appeal-title">圏外通知機能</span>
          <div class="appeal-detail">
            <p>
              受信機が「圏外」になった場合には、ブザーとバイブレーション、圏外表示でお知らせします。
            </p>
            <p>
              お客様は送信機からの信号が届くエリアを把握でき、待ち時間を安心して過ごすことができます。
            </p>
          </div>
        </div>
      </div>

      <div class="feature-content">
        <content-header
          title="32文字メッセージを送信"
          withBorder="true"
          fontColor="black"
          borderColor="green"
          style="width: 75%;"
        />
        <div style="width: 55%;">
          <p>
            受信機画面には全角文字で最大 32 文字のメッセージを表示できます。
          </p>
          <p>
            メッセージはPCアプリで自由に作成でき、256通りまで登録可能です。
          </p>
        </div>

        <img
          v-lazy="'/static/products/remote-reply-call/feature/feature_01.png'"
          style="top: -40px; width: 40%; height: auto;"
          :style="this.$isPC ? '' : 'top: 10px;'"
        />
      </div>

      <div class="feature-content">
        <content-header
          title="新搭載「通信状況チェック機能」でお知らせモレなし！"
          withBorder="true"
          fontColor="black"
          borderColor="green"
          style="width: 75%;"
        />
        <div style="width: 55%;">
          <p>
            受信機に信号が届いたかどうか？お客様がメッセージを確認したかどうか？などの通信状況を逐一、画面に表示。お知らせモレの心配がありません。
          </p>
        </div>
        <img
          v-lazy="'/static/products/remote-reply-call/feature/feature_02.png'"
          style="top: 0; width: 40%; height: auto;"
          :style="this.$isPC ? '' : 'top: 80px;'"
        />
      </div>

      <div class="feature-content">
        <content-header
          title="通信料は無料！ローコストで運用できる"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <p>
          無線局免許を必要としない周波数帯（アンライセンスバンド）を使用する特定小電力無線だから通信料は不要。
        </p>
        <p>
          機器の消費電力も極めて小さく、低コストでシステムを運用できます。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          title="受信機は最大999台まで利用可"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <p>
          送信機には複数の受信機を登録し呼び出せる機能が搭載されています。
          1台の送信機に対し、最大999台の受信機を紐付けすることができます。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          title="高い防水性能を誇る防水・防塵仕様"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <p>
          受信機は防水・防塵仕様なので水洗いができます。飲食店や工場、プール、スキー場などさまざまな場所で利用いただけます！
        </p>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <span class="circle-heading-title"> 利用シーン </span>
        </div>
      </div>

      <div class="use-scene">
        <div class="header">
          <h2>
            遠くにいるお客様も確実に呼び出し、コンシェルジュのようにご案内。
          </h2>
          <p>
            通信エリアは広く、大型のショッピングモールでも全域をカバーできます。
          </p>
        </div>
        <div class="body">
          <div class="use-scene-block">
            <router-link to="/column/23">
              <div class="use-scene-block-header">
                大型ショッピングモール、百貨店で
              </div>
              <img
                v-lazy="
                  '/static/products/remote-reply-call/feature/scene_01.jpg'
                "
              />
            </router-link>
            <p>
              通信エリアは全館全域をカバー。お客様は近隣で待つ必要はなく、
            </p>
            <p>
              自由に買い物を楽しんでいただけます。
            </p>
            <p>
              他にも職員・スタッフへの連絡ツールとしてもお使いいただけます。
            </p>
          </div>
          <div class="use-scene-block">
            <router-link to="/column/21">
              <div class="use-scene-block-header">
                アミューズメント・レジャー施設で
              </div>
              <img
                v-lazy="
                  '/static/products/remote-reply-call/feature/scene_02.jpg'
                "
              />
            </router-link>
            <p>
              受信履歴は最大 5 つまで保存可能 。複数のアトラクションを予約した
            </p>
            <p>
              お客様を、空きが出たものから順番に誘導できますので、順番待ちや
            </p>
            <p>
              行列の解消に役立ちます。
            </p>
          </div>
          <div class="use-scene-block">
            <router-link to="/column/15">
              <div class="use-scene-block-header">
                総合病院で
              </div>
              <img
                v-lazy="
                  '/static/products/remote-reply-call/feature/scene_03.jpg'
                "
              />
            </router-link>
            <p>
              総合病院などで、順番待ちの患者様も好きな場所で快適に、安心して
            </p>
            <p>
              お待ちいただけますので、患者様の待ち時間のストレス解消に役立ちます。
            </p>
          </div>
          <div class="use-scene-block">
            <router-link to="/column/19">
              <div class="use-scene-block-header">
                物流倉庫、工場で
              </div>
              <img
                v-lazy="
                  '/static/products/remote-reply-call/feature/scene_04.jpg'
                "
              />
            </router-link>
            <p>
              多種多様なメッセージ（256 通り）を送信できますので、作業員への
            </p>
            <p>
              連絡ツールとして、搬入・搬出待ちのトラック運転手の誘導ツールとして
            </p>
            <p>
              ご活用いただけます。
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section" v-if="this.$isPC">
      <div class="circle-parent">
        <div class="circle-heading green">
          <span class="circle-heading-title"> 操作の流れ </span>
        </div>
      </div>

      <div class="operation-flow">
        <div class="header">
          <span>
            <h2>
              操作は簡単！メッセージを選び、<br />
              呼び出し番号を押すだけ。
            </h2>
            <p>
              簡単操作でお客様をお呼び出し。 呼出したい受信機ごとに
            </p>
            <p>
              メッセージを切り替えられるので、お客様を確実に誘導できます。
            </p>
          </span>
          <img
            v-lazy="
              '/static/products/remote-reply-call/feature/operation_ten_key.png'
            "
          />
        </div>
        <div class="border" />
        <div class="body">
          <div class="operation-empty" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call/feature/operation_01.png'
              "
            />
            <div class="operation-block-title">
              1. メッセージを選択
            </div>
            <p>
              送信機の❶メッセージ用テンキーで、メッセージを選びます。
            </p>
            <p>
              1～256の番号を入力するとメッセージの文字列が画面に表示されます。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call/feature/operation_02.png'
              "
            />
            <div class="operation-block-title">
              2. 呼び出したい<br />
              &nbsp;&nbsp;&nbsp;&nbsp;受信機の番号を入力
            </div>
            <p>
              ❷呼び出し用テンキーで、呼び出したい受信機の番号（1 ～ 999）を
              入力します。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call/feature/operation_03.png'
              "
            />
            <div class="operation-block-title">
              3. 呼び出し
            </div>
            <p>
              ❸「呼出」ボタンをプッシュして、受信機を呼び出します。
            </p>
            <p>
              「受信機に電波が届いた」「確認ボタンが押された」など、呼び出しの状況がその都度、画面に表示されます。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call/feature/operation_04.png'
              "
            />
            <div class="operation-block-title">
              4. 呼び出し受信
            </div>
            <p>
              受信機は呼び出しを受けると、ブザーとバイブレーション、文字情報でお知らせします。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call/feature/operation_05.png'
              "
            />
            <div class="operation-block-title">
              5. メッセージ表示
            </div>
            <p>
              受信機の確認ボタンを押せば、ブザー音・バイブレーションが止まり、文字情報が表示されます。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call/feature/operation_06.png'
              "
            />
            <div class="operation-block-title">
              6. 画面で通信状況をチェック
            </div>
            <p>
              受信機に信号が届いたかどうか、お客様がメッセージを確認したかどうかなど、送信機の「呼出状況画面」で通信状況をチェックできます。
            </p>
          </div>

          <div class="operation-empty" />
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <span class="circle-heading-title"> 主な機能 </span>
        </div>
      </div>

      <div class="main-function">
        <div class="body">
          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">送信機</h3>
              <div class="product-detail">
                <p>コンパクトな省スペース設計。</p>
                <p>最適メッセージを選び、受信機番号を</p>
                <p>入力し、送信ボタンを押すだけ。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call/feature/function_01.png'
              "
            />
            <div class="function">
              <div class="function-title">
                かんたん呼び出し
              </div>
              <div class="function-detail">
                文字メッセージを選び、呼び出す受信機の番号を入力して<br />
                呼び出すだけ。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                32文字メッセージを送信
              </div>
              <div class="function-detail">
                受信機の画面に全角文字で32文字のメッセージを送ることができます。
                メッセージは最大256通りまで登録可能。<br />
                PCアプリで自由に作成できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                受信機は最大999台まで利用可
              </div>
              <div class="function-detail">
                送信機には複数の受信機を登録し呼び出せる機能が搭載されています。
                1台の送信機で最大999台の受信機を登録できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                受信確認機能を搭載
              </div>
              <div class="function-detail">
                受信機に信号が届いたかどうか、お客様がメッセージを確認したかどうかなど、
                「呼出状況画面」で通信状況をチェックできます。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">受信機</h3>
              <div class="product-detail">
                <p>スマートフォンを思わせるデザイン。</p>
                <p>音、バイブ、文字で呼び出しを知らせ、</p>
                <p>文字情報でご案内。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call/feature/function_02.png'
              "
            />
            <div class="function">
              <div class="function-title">
                音、バイブ、文字で呼び出し
              </div>
              <div class="function-detail">
                ブザー音・バイブレーション・画面表示で呼び出しをお知らせ。<br />
                本体の確認ボタンを押せば停止し、文字情報を表示します。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                送信機へ呼出状況を返信
              </div>
              <div class="function-detail">
                送信機からの呼び出し信号を受信した時、 確認ボタンを押した時<br />
                それぞれの状況を自動で送信機へ返信。送信側は、信号が届いて<br />
                いるかどうかを心配する必要はありません。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                圏外表示機能
              </div>
              <div class="function-detail">
                電波強度表示を搭載。また受信機が「圏外」に移動した場合には、<br />
                異常音とバイブレーション、圏外表示で知らせます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                連続待受36時間
              </div>
              <div class="function-detail">
                フル充電時は連続待ち受け 36 時間のロングライフ設計。<br />
                バッテリー残量表示も搭載しており、安心してご利用いただけます。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">管理機</h3>
              <div class="product-detail">
                <p>複数台送信機システムを</p>
                <p>導入することができます。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call/feature/function_05.png'
              "
            />
            <div class="function">
              <div class="function-title">
                信機と受信機の信号を管理します
              </div>
              <div class="function-detail">
                複数台送信機システムには必ず必要になります。<br />
                管理機は送信機用管理機1台と受信機用管理機1台で1セットです。<br />
                （管理機自体は同じ物です）<br />
                本体裏面のディップスイッチにてどちらの管理機なのか設定を行います。<br />
                送信機用管理機は送信機の予約状況等を確認し受信機用管理機に伝えます。<br />
                受信機用管理機は送信機用管理機からのデータを受信機へ送信します。<br />
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">中継機</h3>
              <div class="product-detail">
                <p>中継機を使えば、通信エリアは</p>
                <p>さらに拡大。</p>
                <p>2台まで増設可能。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call/feature/function_03.png'
              "
            />
            <div class="function">
              <div class="function-title">
                信号の「死角」を無くす
              </div>
              <div class="function-detail">
                信号の到達距離を大幅に延長するとともに、<br />
                障害物による電波干渉など、通信トラブルを解消します。<br />
                中継機は2台まで増設することができます。<br />
                ※&nbsp;中継機間のホッピング（送信機→中継機1→中継機2→受信機）は<br />
                &nbsp;&nbsp;&nbsp;&nbsp;できません。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">充電器</h3>
              <div class="product-detail">
                <p>10台一度に充電可能。</p>
                <p>手入れもしやすい</p>
                <p>コンパクト設計。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call/feature/function_04.png'
              "
            />
            <div class="function">
              <div class="function-title">
                急速充電5時間
              </div>
              <div class="function-detail">
                フル充電には約 5 時間。<br />
                充電状態も受信機の充電用 LED で確認できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                履歴クリア
              </div>
              <div class="function-detail">
                充電器にセットすれば、受信機の履歴は自動的に消去されます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                「充電中」をアラーム表示
              </div>
              <div class="function-detail">
                充電中の受信機を呼び出すことはできません。<br />
                送信機には「充電中」と表示されます。
              </div>
            </div>
          </div>

          <div class="product-block"></div>
        </div>
      </div>
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/2" target="_blank"
            ><img
              src="/static/columns/13/foodcourt_mv.png"
              alt="フードコートの呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/2" target="_blank"
              >フードコートの呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/6" target="_blank"
            ><img
              src="/static/columns/6/img_logistics_operations1.jpg"
              alt="物流倉庫におけるオペレーションの効率化｜工程ごとにポイントを解説"
          /></a>

          <h3>
            <a href="/column/6" target="_blank"
              >物流倉庫におけるオペレーションの効率化｜工程ごとにポイントを解説</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/7" target="_blank"
            ><img
              src="/static/columns/7/img_foodcourt_callbell_mechanism1.jpg"
              alt="フードコートの呼び出しベルの仕組みは？よくある疑問とおすすめ機種"
          /></a>

          <h3>
            <a href="/column/7" target="_blank"
              >フードコートの呼び出しベルの仕組みは？よくある疑問とおすすめ機種</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
  },
}
</script>

<style scoped>
.appeal-block {
  margin: 15px 0;
  padding: 0 15px;
  text-align: center;

  border-radius: 4px;
  background-color: rgb(218, 243, 225);
}

.appeal-block .appeal-title {
  font-weight: bold;

  display: inline-block;

  margin: 20px 30px;
  padding: 12px 30px;

  color: white;
  border-radius: 4px;
  background-color: rgb(73, 195, 108);
}

.appeal-block .appeal-detail {
  font-size: 14px;

  display: inline-block;
  text-align: left;

  vertical-align: middle;
}

.feature-section .use-scene {
  background-color: rgb(218, 243, 225);
}

.feature-section .header h2 {
  color: rgb(45, 183, 68);
}

.feature-section .use-scene .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  max-width: 960px;
  margin: 0 auto;
}

.feature-section .use-scene .body .use-scene-block {
  align-self: flex-start;

  width: 420px;
  margin: 20px 15px;

  text-align: left;
}

.feature-section .use-scene .body .use-scene-block img {
  display: block;

  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 10px auto;

  background-color: #eee;
}

.feature-section .use-scene .body .use-scene-block p {
  font-size: 12px;
  line-height: 22px;

  margin: 0;
}

.feature-section .use-scene .body .use-scene-block .use-scene-block-header {
  font-size: 18px;
  font-weight: bold;

  padding-left: 10px;

  border-left: 4px solid rgb(45, 183, 68);
}

.feature-section .operation-flow {
  width: 900px;
  margin: 0 auto;

  border-radius: 5px;
  background-color: rgb(218, 243, 225);
}

.feature-section .operation-flow .header span {
  display: inline-block;

  width: 450px;

  text-align: left;
}

.feature-section .operation-flow .header img {
  display: inline-block;

  width: 350px;
  height: auto;
}

.feature-section .operation-flow .border {
  margin: 0 40px;

  border-bottom: 1px solid white;
}

.feature-section .operation-flow .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  margin: 20px 0;
}

.feature-section .operation-flow .body .operation-block {
  align-self: flex-start;

  width: 220px;
  margin-bottom: 30px;

  text-align: left;
}

.feature-section .operation-flow .body .operation-block img {
  width: auto;
  height: 130px;
}

.feature-section .operation-flow .body .operation-block .operation-block-title {
  font-weight: bold;
  line-height: 20px;

  margin: 5px 0 10px;
}

.feature-section .operation-flow .body .operation-block p {
  font-size: 13px;

  margin: 0;
}

.feature-section .operation-flow .body .operation-arrow {
  width: 0;
  height: 0;
  margin: 52.5px 20px;

  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid rgb(125, 212, 141);
}

.feature-section .operation-flow .body .operation-empty {
  width: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/RemoteReplyCall.vue